import React, { useEffect, useState } from "react";
import apiUrl from "../../Apiurl";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import stampaFormatoPSdaIDsped from "../Stampe/stampaFormatoPSdaIDsped";
import stampaFormatoATTESE from "../Stampe/stampaFormatoATTESE";
import stampaReportSplit from "../Stampe/stampaReportSplit";

const MAGAZZINI_ROUTINE = [
  { label: "PRATO NEVOSO", valore: "Prato Nevoso" },
  { label: "TORINO", valore: "Torino" },
  { label: "VILLANOVA", valore: "Villanova Mondovì" },
  { label: "LIMONE", valore: "Limone" },
  { label: "BORGO", valore: "Borgo San Dalmazzo" },
  { label: "VERNANTE", valore: "Vernante" },
  { label: "MARRO VS", valore: "Magazzino Marro (area VS)" },
  { label: "MARRO", valore: "Magazzino Marro" },
];

const ALIAS_RITIRI_MAGAZZINO = {
  "Prato Nevoso": ["Ritiro a Prato N."],
  "Villanova Mondovì": ["Ritiro a Villanova M."],
  "Borgo San Dalmazzo": ["Ritiro a Borgo"],
};

function creaListaMagazziniRoutine(magazzino) {
  return [
    magazzino,
    "Ritiro a " + magazzino,
    "Ritiro - " + magazzino,
    ...(ALIAS_RITIRI_MAGAZZINO[magazzino] || []),
  ];
}

function RoutineMattutina({ mobile, temaColori, utente }) {
  const { user, /* isAuthenticated,  */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [mag, setMag] = useState(false);
  const [passaggi, setPassaggi] = useState([]);
  const [numPassaggio, setNumPassaggio] = useState(1);
  const [conferma, setConferma] = useState(false);
  const [TOT, setTOT] = useState(false);
  const [listaOrdini, setListaOrdini] = useState(false);
  const [stampePS, setStampePS] = useState(false);
  const [stampeAlt, setStampeAlt] = useState(false);
  const [stampeSplit, setStampeSplit] = useState(false); // NUOVO STATO

  function scegliMag(mag) {
    /* const nuoviPassaggi = [...passaggi];
        nuoviPassaggi.push(passaggio2) */
    setNumPassaggio(2);
    setMag(mag);
    /* setPassaggi(nuoviPassaggi); */
  }

  const fetch = async (magazzino) => {
    // faccio questo accrocchio ma la cosa va ragionata appena possibile:
    const magazzini = creaListaMagazziniRoutine(magazzino);

    console.log("fetch");
    const nuoviParams = new URLSearchParams({
      magazzino: magazzino,
      magazzini: magazzini,
      userName: user.name,
    });
    const response = await axios.get(
      apiUrl +
        "/logistica/ricerca/ricercaOrdiniDBelencoPerStampe?" +
        nuoviParams
    );

    // Logica esistente
    response?.data?.stampePS && setStampePS(response.data.stampePS);
    response?.data?.stampeAlt && setStampeAlt(response.data.stampeAlt);

    // NUOVA LOGICA: Filtro ordini che sono stati splittati
    const split =
      (response?.data?.stampePS || [])
        .filter((ord) => ord.split === 1);
    setStampeSplit(split);

    setListaOrdini(response.data);
    setNumPassaggio(5);
    console.log("fatto tutto");
  };

  const fetchTot = async (magazzino) => {
    // faccio questo accrocchio ma la cosa va ragionata appena possibile:
    const magazzini = creaListaMagazziniRoutine(magazzino);

    const nuoviParams = new URLSearchParams({
      "sped.Stato_Ordine IN": ["PREPARAZIONE"],
      "sped.Partenza_da IN": magazzini,
    });
    const response = await axios.get(
      apiUrl +
        "/logistica/ricerca/ricercaOrdiniDBavanzataSOLOTOT?" +
        nuoviParams
    );
    setTOT(response.data.tot);
    setNumPassaggio(3);
  };

  //CONTROLLA PARAMETRI pagination 1/100

  useEffect(() => {
    const arr = [];
    arr.push({
      icona: (
        <div class="flex items-center justify-center material-symbols-outlined f2 sfondoColMedio scrittaColChiaro br-100 h-100">
          warehouse
        </div>
      ),
      content: (
        <div>
          <div className="ttu f4 b mb3">Scegli il magazzino</div>
          {!listaOrdini && (
            <div className="flex flex-wrap">
              {MAGAZZINI_ROUTINE.map((magazzino) => (
                <button
                  key={magazzino.valore}
                  onClick={() => scegliMag(magazzino.valore)}
                  className={`${stilePulsanti.buttonClassesWhite} mb2 mr2`}
                >
                  {magazzino.label}
                </button>
              ))}
            </div>
          )}
        </div>
      ),
      date: false,
    });
    if (mag && numPassaggio === 2) {
      fetchTot(mag);
    }
    if (numPassaggio > 2 && typeof TOT === "number") {
      arr.push({
        icona: (
          <div class="flex items-center justify-center material-symbols-outlined f2 sfondoColMedio scrittaColChiaro br-100 h-100">
            question_mark
          </div>
        ),
        content: (
          <div>
            <div className="ttu f4 b mb3">Hai scelto {mag}</div>
            <div className="ttu f4 mb3">
              Ci sono <strong>{TOT ? TOT : "0"}</strong> ordini da mettere in
              ricerca
            </div>
            {TOT > 0 && (
              <div className="f5 mb3">
                Sei sicuro? Clicca qui per impostare tutti gli ordini
                attualmente in PREPARAZIONE sul tuo magazzino nello stato
                RICERCA
              </div>
            )}
            {TOT > 0 && !listaOrdini && (
              <button
                onClick={() => setNumPassaggio(4)}
                className={stilePulsanti.buttonClassesWhite}
              >
                SI', PRENOTA ORDINI
              </button>
            )}
          </div>
        ),
        date: false,
      });
    }
    if (numPassaggio === 4) {
      fetch(mag);
    }
    if (listaOrdini && numPassaggio > 4) {
      let idPerStampePS;
      let idPerStampeAlt;
      if (stampePS) {
        idPerStampePS = stampePS.map((row) => ({
          idSped: row.idSped,
          idPS: row.idPS,
          fonteOrdine: row.fonteOrdine || row.fonte || "VIG",
        }));
      }
      if (stampeAlt) {
        idPerStampeAlt = stampeAlt.map((row) => row.idSped);
      }
      arr.push({
        icona: (
          <div class="flex items-center justify-center material-symbols-outlined f2 sfondoColMedio scrittaColChiaro br-100 h-100">
            print
          </div>
        ),
        content: (
          <div>
            <div className="ttu f4 b mb3">STAMPA GLI ORDINI</div>
            <div className="f5 mb3">
              Hai prenotato{" "}
              {listaOrdini.arrIdTUTTI.length
                ? listaOrdini.arrIdTUTTI.length
                : "0"}{" "}
              ordini
            </div>
            {stampePS.length > 0 && (
              <button
                className={stilePulsanti.buttonClassesWhite}
                onClick={() =>
                  stampaFormatoPSdaIDsped(token, idPerStampePS, true)
                }
              >
                STAMPA {stampePS.length} ORDINI
              </button>
            )}
            {stampeAlt.length > 0 && (
              <button
                className={stilePulsanti.buttonClassesWhite}
                onClick={() =>
                  stampaFormatoATTESE(token, idPerStampeAlt, true, null, null)
                }
              >
                STAMPA {stampeAlt.length} AGGIUNTE
              </button>
            )}
            {stampeSplit.length > 0 && (
              <button
                className={stilePulsanti.buttonClassesWhite}
                style={{ backgroundColor: "orange" }}
                onClick={() => stampaReportSplit(token, stampeSplit, mag)}
              >
                STAMPA {stampeSplit.length} MODIFICHE/SPLIT
              </button>
            )}
            {/* <pre className='w-50'>{JSON.stringify(listaOrdini, null, 2)}</pre> */}
          </div>
        ),
      });
      setPassaggi(arr);
    }
    setPassaggi(arr);
  }, [mag, numPassaggio]);

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };
    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  function elementoPassaggio(passaggio) {
    let position = "right";
    let contentStyle = {
      "background-color": "var(--colChiaro)",
      color: "black",
      "border-top": "3px solid var(--colScuro)",
    };
    let contentArrowStyle = { borderRight: "7px solid var(--colChiaro)" };
    let dateClassName = "mr3 ml3 black ttu";
    let date = passaggio.date;
    let iconStyle = { background: "#FFDFDF" };
    let icon = passaggio.icona;
    let content = passaggio.content;

    return (
      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        position={position}
        contentStyle={contentStyle}
        contentArrowStyle={contentArrowStyle}
        date={date}
        dateClassName={dateClassName}
        iconStyle={iconStyle}
        icon={icon}
      >
        {content}
      </VerticalTimelineElement>
    );
  }

  return (
    <div className="sfondoBiancoTema timeline sezioneConScroll flex justify-center h-100 w-100">
      <div className="flex mw6">
        <VerticalTimeline lineColor={"#001B44"} layout={"1-column-left"}>
          {passaggi.map((passaggio) => elementoPassaggio(passaggio))}
        </VerticalTimeline>
      </div>

      {/* <div className="f1 pa4">{numPassaggio}</div> */}
    </div>
  );
}

export default RoutineMattutina;
